const { config, version } = require("../../package.json");
let gitDisplayVersion;
try {
    gitDisplayVersion = require("cfg/version.json");
} catch {}

const getEnvironment = (backend = config.backend) => {
    if (backend == "alt") {
        const prod = Object.assign({}.require("./prod/production").default);
        const alt = require("./alt/alternate").default;
        prod.AWS.Auth = alt.AWS.Auth;
        return prod;
    }

    let secrets;
    let env;

    if (backend === "prod") {
        secrets = require("./prod/secrets.json");
        env = require("./prod/production").default;
    } else if (backend === "qa") {
        secrets = require("./qa/secrets.json");
        env = require("./qa/qa").default;
    } else if (backend === "prod-eu") {
        secrets = require("./prod-eu/secrets.json");
        env = require("./prod-eu/prod-eu").default;
    } else if (backend === "dev-eu") {
        secrets = require("./dev-eu/secrets.json");
        env = require("./dev-eu/dev-eu").default;
    } else {
        secrets = require("./dev/secrets.json");
        env = require("./dev/development").default;
    }

    secrets = secrets.profiles[config.serviceProfile];

    return Object.assign(env, secrets);
};

const getTargetRegionConfig = (currentBackend) => {
    // Determine target backend based on region switching logic
    let targetBackend;

    if (currentBackend === "prod") {
        targetBackend = "prod-eu";
    } else if (currentBackend === "prod-eu") {
        targetBackend = "prod";
    } else if (currentBackend === "qa") {
        targetBackend = "dev-eu";
    } else if (currentBackend === "dev-eu") {
        targetBackend = "qa";
    } else {
        // For local development or other cases, return current config
        return getEnvironment();
    }

    // Use the parameterized getEnvironment with target backend
    return getEnvironment(targetBackend);
};

const defaultConfig = getEnvironment();
defaultConfig.backend = config.backend;
defaultConfig.environment = config.backend;
defaultConfig.isCloudDeployment = config.isCloudDeployment;
defaultConfig.version = gitDisplayVersion;
defaultConfig.serviceProfile = config.serviceProfile;
defaultConfig.semver = version;
defaultConfig.wsBaseUrl = `${defaultConfig.wsBaseUrl}/${config.serviceProfile}`;

if (!config.isCloudDeployment) {
    defaultConfig.AWS.oauth.redirectSignIn = "http://localhost:3000/";
    defaultConfig.AWS.oauth.redirectSignOut = "http://localhost:3000/signout";
    defaultConfig.wsBaseUrl = `ws://localhost:5100`;
    defaultConfig.microstrategy.mstrWebUrl =
        "http://localhost:8081/MicroStrategy/servlet/";
}

defaultConfig.getTargetRegionConfig = getTargetRegionConfig;

export default defaultConfig;
